module.exports = __webpack_public_path__ + "static/media/graphic-orangecloud.ff94be0d.png";